import { useCallback } from 'react'
import { useAppDispatch } from '../redux/store'
import { showSuccessMessage } from '../redux/reducers/snackbarReducer'
import { manualRequestsService } from '../services/myActionsService'
import { RtwMaintenanceRequest } from '../types/return-to-work'

/**
 * Custom hook for RTW-related operations
 */
export const useRtwOperations = () => {
  const dispatch = useAppDispatch()

  const fetchRtwData = useCallback(
    async (absenceId: number) => {
      const result = await manualRequestsService.getRTW(absenceId)
      return result
    },
    [dispatch]
  )

  const saveRtwData = useCallback(
    async (data: RtwMaintenanceRequest) => {
      const result = await manualRequestsService.saveRTW(data)
      dispatch(showSuccessMessage('RTW has been successfully saved'))
      return result
    },
    [dispatch]
  )

  const insertRtwData = useCallback(
    async (data: RtwMaintenanceRequest) => {
      const result = await manualRequestsService.insertRTW(data)
      dispatch(showSuccessMessage('RTW has been successfully saved'))
      return result
    },
    [dispatch]
  )

  return {
    fetchRtwData,
    saveRtwData,
    insertRtwData,
  }
}